/**
 * Jewels of Toronto collection aliases.
 * Keeps legacy gender-specific storefront links working while Wedding Bands
 * remains the parent collection for the dedicated Women's and Men's subcategories.
 */
(() => {
  const routes = Object.freeze({
    '/collections/women-s': '/collections/women-s-wedding-bands',
    '/collections/men-s': '/collections/men-s-wedding-bands'
  });

  const normalizePath = (pathname) => pathname.replace(/\/+$/, '') || '/';
  const currentPath = normalizePath(window.location.pathname);
  const currentTarget = routes[currentPath];

  if (currentTarget) {
    window.location.replace(currentTarget + window.location.search + window.location.hash);
    return;
  }

  const updateCollectionLinks = () => {
    document.querySelectorAll('a[href]').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin) return;

      const target = routes[normalizePath(url.pathname)];
      if (!target) return;

      link.href = target + url.search + url.hash;
    });
  };

  const compactScreen = window.matchMedia('(max-width: 749px)');
  const setupDisclosures = () => {
    document.querySelectorAll('[data-joa-responsive-details]:not([data-joa-disclosure-ready])').forEach(details => {
      details.open = !compactScreen.matches;
      details.dataset.joaDisclosureReady = 'true';
    });
  };
  const setShapes = ['oval', 'radiant', 'marquise', 'pear', 'cushion', 'emerald', 'round'];
  const updateSets = () => {
    const results = document.querySelector('[data-joa-set-results]');
    const controls = results?.querySelector('[data-joa-set-controls]');
    if (!controls) return;
    const cards = [...results.querySelectorAll('[data-joa-set-memberships]')];
    if (cards.length !== Number(results.dataset.joaSetTotal)) return;
    const hash = new URLSearchParams(location.hash.slice(1));
    const shape = setShapes.includes(hash.get('shape')) ? hash.get('shape') : 'all';
    const matches = (card, value) => value === 'all' || card.dataset.joaSetMemberships.split(' ').includes(value) || card.dataset.joaSetTitle.split('-')[0] === value;
    let count = 0;
    cards.forEach(card => { card.hidden = !matches(card, shape); if (!card.hidden) count++; });
    controls.hidden = false;
    results.dataset.joaSetReady = 'true';
    controls.querySelectorAll('[data-joa-set-shape]').forEach(button => {
      const value = button.dataset.joaSetShape;
      button.hidden = value !== 'all' && value !== shape && !cards.some(card => matches(card, value));
      button.setAttribute('aria-pressed', String(value === shape));
    });
    const status = controls.querySelector('[data-joa-set-count]');
    const message = status.dataset.countTemplate.replace('__COUNT__', count);
    if (status.textContent !== message) status.textContent = message;
    controls.querySelector('[data-joa-set-empty]').hidden = count > 0;
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-joa-set-shape]');
    if (!button) return;
    const url = new URL(location.href);
    url.hash = button.dataset.joaSetShape === 'all' ? '' : `shape=${button.dataset.joaSetShape}`;
    history.pushState({}, '', url);
    updateSets();
  });
  window.addEventListener('hashchange', updateSets);
  window.addEventListener('popstate', updateSets);
  const setupCollection = () => {
    setupDisclosures(); updateSets();
    const results = document.querySelector('results-list');
    if (!results) return;
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; setupDisclosures(); updateSets(); });
    }).observe(results, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCollectionLinks, { once: true });
  } else {
    updateCollectionLinks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupCollection, { once: true });
  else setupCollection();
})();
